function selectingMI(item, select) {
    let parent = item.closest('.dropdown__content')
    parent.setAttribute('selected', select)

    const selectedItem = document.querySelector(`[select="${select}"]`)
    const otherItems = document.querySelectorAll(`[select]:not([select="${select}"])`)

    showSelectMI(selectedItem, otherItems)
}

function showSelectMI(selected, other) {
    selected.style = 'max-height: 4000px;'
    for (const item of other) {
        item.style = 'max-height: 1px; overflow: hidden; pointer-events: none;'
    }
    openClosedMI(document.querySelector('.froze'))
}

function hiddenUnselectMI() {
    onload = () => {
        const moldingItems = document.querySelectorAll('.Product-description__molding-select-wrapper')
        if (!moldingItems.length) return
        const selectedItemAttr = document.querySelector('.dropdown__content[selected]')
        for (let moldingItem of moldingItems) {
            if (moldingItem.getAttribute('select') !== selectedItemAttr.getAttribute('selected')) {
                moldingItem.style = 'max-height: 1px; overflow: hidden; pointer-events: none;'
            }
        }
    }
}

function disabledCheckboxBlocks(item = null) {
    const checkboxes = document.querySelectorAll('.molding-title-heading__checkbox')

    if (!checkboxes.length) return

    for (const checkbox of checkboxes) {
        
        const inner = checkbox.closest('.Product-description__molding-select-inner')

        if (checkbox.querySelector('[type="checkbox"]').checked) {
            inner.removeAttribute('disabled')
        } else {
            inner.setAttribute('disabled', '')
        }
    }

    if (!item) return

    const checkbox = item.querySelector('[type="checkbox"]')
    const inner = checkbox.closest('.Product-description__molding-select-inner')

    if (checkbox.checked) {
        inner.removeAttribute('disabled')
    } else {
        inner.setAttribute('disabled', '')
    }

    return 
}